export default class FilterFwg {
	static install(Vue, options) {
		Vue.filter('fwgshortorder', function (value, length = 3) {
      if (value && value.length > length) {
        return value.substr(value.length - length)
      }
      return value
    })
    Vue.filter('fwgprice', function(value) {
      return value ? "CHF " + value.toFixed(2) : "CHF 0.00"
    })
    Vue.filter('fwgpricecent', function (value, mode = "long") {
			let prefix = ""
			if (mode == "long") {
				prefix = "CHF "
			}
			else if (mode == "html") {
				prefix = "CHF&nbsp;"
			}

			let v = value / 100
			v = v || 0
			return prefix + v.toFixed(2)
		})
	}
}
